import {createBrowserRouter, RouterProvider} from 'react-router-dom';
import Layout from '../components/ui/Layout';
import Home from '../pages/Home';
import About from '../pages/About';
import VisitorManagementSoftware from "../pages/Products/VisitorManagementSoftware";
import NotFound from "../pages/NotFound";
import MeetingRoomManagement from "../pages/Products/MeetingRoomManagement";
import ErpSolutions from "../pages/Services/ErpSolutions";
import MobileDevelopment from "../pages/Services/MobileDevelopment";
import WebApplicationDevelopment from "../pages/Services/WebApplicationDevelopment";
import PaperlessBoardMeeting from "../pages/Products/PaperlessBoardMeeting";
import Loading from "../components/common/Loading";
import WorkFlow from "../pages/Products/WorkFlow";
import FileCloud from "../pages/Products/FileCloud";
// import ItNetworkingReportingAppliance from "../pages/Products/ItNetworkingReportingAppliance";
import CustomizedSoftware from "../pages/Services/CustomizedSoftware";
import '../assets/css/fonts.css';
import ContactPage from "../pages/ContactPage";
import Careers from "../pages/Careers";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import EnvironmentalMonitoring from "../pages/Products/EnvironmentalMonitoring";
import WeedsBlackBoxSuite from "../pages/Products/WeedsBlackBoxSuite";
import AnyDb from "../pages/Products/AnyDb";
import FortinetPage from "../pages/Services/FortinetPage";

// ✅ Define all routes here
const router = createBrowserRouter([
  {
    path: '/',
    // loader: <Loading />,
    element: <Layout />,
    children: [
      { path: '/', element: <Home /> },
      { path: '/loading', element: <Loading /> },
      // { path: '/slider', element: <TestSlide /> },
      { path: '/about', element: <About /> },
      { path: '/contact', element: <ContactPage /> },
      { path: '/careers', element: <Careers /> },
      { path: '/privacy-policy/', element: <PrivacyPolicy /> },
      {
        path: '/products',
        children: [
          { path: 'visitor-management-software', element: <VisitorManagementSoftware /> },
          { path: 'meeting-room-solutions', element: <MeetingRoomManagement /> },
          { path: 'paperless-board-meeting', element: <PaperlessBoardMeeting /> },
          { path: 'c-flow', element: <WorkFlow /> },
          { path: 'file-cloud', element: <FileCloud /> },
          // { path: 'it-networking-reporting-appliance', element: <ItNetworkingReportingAppliance /> },
          { path: 'environment-monitoring-system', element: <EnvironmentalMonitoring /> },
          { path: 'weeds-black-box-suite', element: <WeedsBlackBoxSuite /> },
          { path: 'anydb', element: <AnyDb /> }
        ],
      },
      {
        path: '/services',
        children: [
          { path: 'web-application-development', element: <WebApplicationDevelopment /> },
          { path: 'mobile-development', element: <MobileDevelopment /> },
          { path: 'customized-software', element: <CustomizedSoftware /> },
          { path: 'erp-solutions', element: <ErpSolutions /> },
          { path: 'it-solutions', element: <FortinetPage /> },
        ],
      },
      { path: '*', element: <NotFound /> },
    ],
  },
]);

// ✅ Component to wrap RouterProvider and show Loading state
const Router = () => {

  return (
    <>
      <RouterProvider router={router} />
    </>
  );
};

export default Router;
